import React, { ReactNode } from 'react';
import { Select, SeverityItem } from '@fabric-ui/components';
import { Box } from '@mui/material';
import { IconVariant, ItemWithLogo } from '../../ItemWithLogo';

interface FilterByListProps {
  label: ReactNode;
  isLoadingOptions: boolean;
  isSeverity: boolean;
  isTextField: boolean;
  options: any[];
  value: any[];
  onChange: (field: any, val: any) => void;
  field: string;
  type: string;
  onFilterChange: ((filter: any) => void) | undefined;
  totalOptionsCount: number;
  isSchemaField: boolean;
  setSearch: (search: string) => void;
  excludeNullFromList?: boolean;
}

export const FilterByList: React.FC<FilterByListProps> = ({
  label,
  isLoadingOptions,
  isSeverity,
  isTextField,
  options,
  value,
  onChange,
  field,
  type,
  onFilterChange,
  totalOptionsCount,
  isSchemaField,
  setSearch,
  excludeNullFromList,
}) => (
  <Box sx={{ px: 1, mt: 1, pb: 1, display: 'block' }}>
    <Select
      showOnlyAutoComplete
      size="small"
      acceptNullValue={!excludeNullFromList}
      label={label as React.ReactNode}
      variant="filter"
      loading={isLoadingOptions}
      {...(isSeverity && { renderOption: ({ value }: any) => <SeverityItem value={value} /> })}
      isMultiple
      showInput={isTextField}
      options={options}
      value={value}
      onChange={val => {
        onChange([field], val);
        if (type === 'string') {
          const hasNull = val.includes(null);
          const nonNullValues = val.filter((v: any) => v !== null);
          onFilterChange?.({
            expression: {
              fieldName: field,
              stringCondition:
                val.length > 0 ? { in: { values: nonNullValues }, ...(hasNull && { addNullFilter: true }) } : { contains: '' },
            },
          });
        }
      }}
      totalOptionsCount={totalOptionsCount}
      renderOption={
        field.endsWith('.source_names')
          ? ({ value }: any) => <ItemWithLogo variant={IconVariant.sourcesMapByName} type={value} textStyle={{ overflow: 'auto' }} />
          : undefined
      }
      filterFunc={
        isSchemaField
          ? (options, { inputValue }) => {
              setSearch(inputValue);
              return options;
            }
          : undefined
      }
    />
  </Box>
);
